import { ofType } from 'redux-observable';
import { switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { fromPromise } from 'rxjs/observable/fromPromise';

import { theme } from '@src/services';
import * as actions from '@src/store/actions';
import * as types from '@src/store/types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getThemesClientCall = action$ => action$.pipe(
	ofType(types.GET_THEMES_CLIENT_CALL),
	switchMap(({ payload }) => fromPromise(theme.getThemes(payload)).pipe(
		switchMap(res => of(
			actions.getThemesClientDone(res),
		)),
		catchError(err => of(actions.getThemesClientFail(err))),
	)),
);
